// userTypeSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserTypeState {
    profile: {
        numberOfEmployees: string;
        numberOfActivities: string;
        locations: string[];
        reservation: boolean;
        legalCompanyName: string;
        website: string;
        user: string;
        type: string;
        _id: string;
        __v: number;
    } | null;
    success: boolean;
    message: string;
}

const initialState: UserTypeState = {
    profile: null,
    success: false,
    message: '',
};

const userTypeSlice = createSlice({
    name: 'userType',
    initialState,
    reducers: {
        setUserProfile: (state, action: PayloadAction<UserTypeState>) => {
            state.profile = action.payload.profile;
            state.success = action.payload.success;
            state.message = action.payload.message;
        },
    },
});

export const { setUserProfile } = userTypeSlice.actions;
export default userTypeSlice.reducer;
